var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { MethodType, isEmpty, getMethodPrefix, IMCtrl, isEqual } from "../common/helper";
var GcInputManComponents = /** @class */ (function (_super) {
    __extends(GcInputManComponents, _super);
    function GcInputManComponents(props) {
        var _this = _super.call(this, props) || this;
        _this._ref = React.createRef();
        return _this;
    }
    GcInputManComponents.prototype.renderChildren = function () {
        var _this = this;
        React.Children.forEach(this.props.children, function (child) {
            if (child && typeof child === 'object') {
                child.props._parent = _this;
            }
        });
        return this.props.children;
    };
    GcInputManComponents.prototype.render = function () {
        return React.createElement("div", { id: this.props.id, className: this.props.className, ref: this._ref }, this.renderChildren());
    };
    GcInputManComponents.prototype.componentDidUpdate = function (previousProps) {
        var _this = this;
        Object.keys(this.props).forEach(function (key) {
            if (_this.props[key] === undefined || key === 'children' || key === '_parent') {
                return;
            }
            if (isEqual(previousProps[key], _this.props[key]) && _this.processInteractiveProps(key, previousProps, _this.props)) {
                return;
            }
            try {
                if (_this.isSetAccessor(key)) {
                    _this._imCtrl[key] = _this.props[key];
                    return;
                }
                var setter = _this.tryGetPropertyOperator(key, MethodType.setter);
                if (_this.hasRealMethod(setter)) {
                    var args = _this.props[key];
                    if (_this.propDic && _this.propDic[key] && _this.propDic[key].paramResolve) {
                        args = _this.propDic[key].paramResolve(args);
                    }
                    if (_this.propDic && _this.propDic[key] && _this.propDic[key].isPramArr === true) {
                        _this._imCtrl[setter].apply(_this._imCtrl, args);
                    }
                    else {
                        _this._imCtrl[setter](args);
                    }
                }
            }
            catch (_a) {
            }
        });
    };
    GcInputManComponents.prototype.isSetAccessor = function (key) {
        var descriptor = Object.getOwnPropertyDescriptor(this._imCtrl.constructor.prototype, key);
        if (descriptor && descriptor.set) {
            return true;
        }
        return false;
    };
    GcInputManComponents.prototype.tryGetPropertyOperator = function (propertyName, methodType) {
        if (this.propDic && this.propDic[propertyName]) {
            var method = methodType === MethodType.getter ? this.propDic[propertyName].getter : this.propDic[propertyName].setter;
            if (!isEmpty(method)) {
                return method;
            }
            else {
                return "";
            }
        }
        return getMethodPrefix(methodType) + propertyName[0].toUpperCase() + propertyName.slice(1);
    };
    GcInputManComponents.prototype.hasRealMethod = function (methodName) {
        return this._imCtrl && typeof this._imCtrl[methodName] === "function";
    };
    GcInputManComponents.prototype.componentWillUnmount = function () {
        this.destroyGcComponent(this._ref.current);
    };
    GcInputManComponents.prototype.componentDidMount = function () {
        this._imCtrl = this.initGcComponent(this._ref.current);
        this.bindEvent();
        this.activeNoneConfigProps();
        if (this._ref.current) {
            this._ref.current[IMCtrl] = this._imCtrl;
        }
    };
    GcInputManComponents.prototype.setElementName = function (element) {
        if (element && this.props.name) {
            element.setAttribute('name', this.props.name);
        }
    };
    GcInputManComponents.prototype.activeNoneConfigProps = function () { };
    ;
    GcInputManComponents.prototype.processInteractiveProps = function (key, previousProps, currentProps) {
        return true;
    };
    GcInputManComponents.prototype.getNestedIMControl = function () {
        return this._imCtrl;
    };
    return GcInputManComponents;
}(React.Component));
export { GcInputManComponents };
